import {
  institutionDateTimeInputValue,
  institutionLocalDateTimeToIso,
} from '../uitilites/institutionTime';

export const BREAK_GLASS_MAX_HOURS = 4;

const toLocalDateTimeInput = (value) => {
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  const offset = date.getTimezoneOffset() * 60000;
  return new Date(date.getTime() - offset).toISOString().slice(0, 16);
};

export const breakGlassExpiryLimits = (now = new Date(), timezone = '') => ({
  min: timezone ? institutionDateTimeInputValue(now, timezone) : toLocalDateTimeInput(now),
  max: timezone
    ? institutionDateTimeInputValue(
      new Date(now.getTime() + (BREAK_GLASS_MAX_HOURS * 60 * 60 * 1000)),
      timezone,
    )
    : toLocalDateTimeInput(new Date(now.getTime() + (BREAK_GLASS_MAX_HOURS * 60 * 60 * 1000))),
});

export const validateBreakGlassExpiry = (value, now = new Date(), timezone = '') => {
  const parsedValue = timezone ? institutionLocalDateTimeToIso(value, timezone) : value;
  const expiresAt = parsedValue ? new Date(parsedValue) : null;
  if (!expiresAt || Number.isNaN(expiresAt.getTime())) return 'Choose a valid emergency access expiration time.';
  if (expiresAt <= now) return 'Emergency access expiration must be in the future.';
  if (expiresAt > new Date(now.getTime() + (BREAK_GLASS_MAX_HOURS * 60 * 60 * 1000))) {
    return `Emergency access cannot exceed ${BREAK_GLASS_MAX_HOURS} hours.`;
  }
  return '';
};

export const isValidIanaTimezone = (value) => {
  const timezone = String(value || '').trim();
  if (!timezone) return false;
  try {
    new Intl.DateTimeFormat('en-US', { timeZone: timezone }).format();
    return true;
  } catch (_) {
    return false;
  }
};

export const setLicenseFeature = (license, feature, enabled) => {
  const featureEntitlements = {
    ...(license.feature_entitlements || {}),
    [feature]: enabled,
  };
  if (feature === 'api_connections' && enabled === false) featureEntitlements.foresight = false;
  if (feature === 'foresight' && featureEntitlements.api_connections === false) featureEntitlements.foresight = false;
  return { ...license, feature_entitlements: featureEntitlements };
};

export const supportGrantIsActive = (grant, now = new Date()) => (
  grant?.is_active === true
  && !grant.revoked_at
  && Boolean(grant.expires_at)
  && new Date(grant.expires_at) > now
);

export const activeBreakGlassGrant = (responseData, now = new Date()) => {
  const grants = Array.isArray(responseData) ? responseData : (responseData?.grants || []);
  return grants.find((grant) => supportGrantIsActive(grant, now)) || null;
};
